import { GICTransaction } from "./GICTransaction"
import Utils from "../portlibs/PortUtils"

export class BondTransaction extends GICTransaction{
    override get coupon() { return this.quantity*this.yield/200}
    
    override get payout(){ 
        const numCoupons = Math.ceil( Utils.diffDate(this.date, this.maturity)/Utils.SixMonth )
        return this.coupon*numCoupons + this.quantity - this.quantity;
    }
    override get principal(){return this.quantity}
    override clone(reset?:boolean){
        const ret = new BondTransaction(this.holding, this)
        if (reset) ret.json._id = ""
        return ret
    }
}